export default __webpack_public_path__ + "static/media/dados-cadastrais.581d910d.svg";